export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '项目基础材料信息',
  dynamicParam: '/:mode/:id?',
} as TCommon.RouteConfig
